import { Achievement } from '@/models';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';

@Component({
  name: 'CmgCelebrateAchievementModal',
})
export default class CmgCelebrateAchievementModal extends Vue {
  @Watch('visible', { immediate: true })
  async visibleChanged(newVisible: boolean) {
    if (newVisible) {
      setTimeout(() => {
        (window as any).LottieInteractivity.create({
          player: '#achievementLottie',
          mode: 'chain',
          actions: [
            {
              state: 'autoplay',
              transition: 'onComplete',
              path: this.lottieIntroSparkUrl
            },
            {
              state: 'loop',
              transition: 'none',
              path: this.lottieBackgroundSparklesUrl
            }
          ]
        });
      }, 0);
    }
  }

  get isMilestone(): boolean {
    return this.achievement.badgeType.toLowerCase() === 'milestone';
  }

  get lottieIntroSparkUrl(): string {
    return this.isMilestone
      ? 'https://assets3.lottiefiles.com/packages/lf20_f066j7wf.json'
      : 'https://assets2.lottiefiles.com/packages/lf20_ym5i8d2l.json'
  }

  get lottieBackgroundSparklesUrl(): string {
    return this.isMilestone
      ? 'https://assets8.lottiefiles.com/packages/lf20_xjs89xjm.json'
      : 'https://assets2.lottiefiles.com/packages/lf20_das3h30q.json'
  }

  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  get visible(): boolean {
    return this.$appStore.state.ui.modals.celebrateAchievement.visible;
  }

  get achievement(): Achievement {
    return this.$appStore.state.ui.modals.celebrateAchievement.args!.achievement;
  }

  get achievementDate(): string {
    return new Date(this.achievement.achievementDate).toLocaleDateString();
  }

  get achievementSparkUrl(): string {
    return this.$appStore.state.cms.images.backgrounds.extrasAchievementSpark.default;
  }

  onClose() {
    this.$services.ui.setModalVisibility('celebrateAchievement', false);
  }
}
